import { render, staticRenderFns } from "./TeachingPersonalArticle.vue?vue&type=template&id=5b6d4090&scoped=true"
import script from "./TeachingPersonalArticle.vue?vue&type=script&lang=js"
export * from "./TeachingPersonalArticle.vue?vue&type=script&lang=js"
import style0 from "./TeachingPersonalArticle.vue?vue&type=style&index=0&id=5b6d4090&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d4090",
  null
  
)

export default component.exports